import { SET_SUBSCRIPTION, SET_SUBSCRIPTIONS } from "../../constants/subscriptionConstants";

export const setSubscription = (subscription) => {
  return {
    type: SET_SUBSCRIPTION,
    subscription,
  };
};

export const setSubscriptions = (subscriptions, filtered = false) => {
  return {
    type: SET_SUBSCRIPTIONS,
    subscriptions,
    filtered,
  };
};
